import { IButton } from "../Button/IButton";
import { ButtonTextStyle } from "./ButtonTextStyle";

export function ButtonText({ text }: IButton) {
  return <ButtonTextStyle>{text}</ButtonTextStyle>;
}
